import React from 'react';
import { Container, ImpactLabel } from './styles';

interface Props {
  name: string;
}

const ImpactAxis: React.FC<Props> = ({ name }) => {
  return (
    <Container id={name} name={name}>
      {name === 'low-impact' ? (
        <ImpactLabel>Sehr geringer Impact</ImpactLabel>
      ) : (
        <ImpactLabel>Sehr hoher Impact</ImpactLabel>
      )}
    </Container>
  );
};

export default ImpactAxis;
